import { reactive, ref } from 'vue';

// mirrors the anchor validator of the backend FeatureBadge model
export const ANCHOR_PATTERN = /^[a-z][a-zA-Z0-9.-]*$/;

export const anchorsMode = ref(false);

const rendered = reactive(new Map<string, number>());

export const registerAnchor = (anchor: string) => {
  rendered.set(anchor, (rendered.get(anchor) ?? 0) + 1);
};

export const unregisterAnchor = (anchor: string) => {
  const left = (rendered.get(anchor) ?? 0) - 1;

  if (left > 0) {
    rendered.set(anchor, left);
  } else {
    rendered.delete(anchor);
  }
};

export const isAnchorRendered = (anchor: string) => rendered.has(anchor);
